var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.375 110C35.4583 110 33.8333 109.333 32.5 108C31.1667 106.667 30.5 105.042 30.5 103.125V16.875C30.5 14.9583 31.1667 13.3333 32.5 12C33.8333 10.6667 35.4583 10 37.375 10H83.625C85.5417 10 87.1667 10.6667 88.5 12C89.8333 13.3333 90.5 14.9583 90.5 16.875V103.125C90.5 105.042 89.8333 106.667 88.5 108C87.1667 109.333 85.5417 110 83.625 110H37.375ZM34.375 99.25V103.125C34.375 103.875 34.6875 104.563 35.3125 105.188C35.9375 105.813 36.625 106.125 37.375 106.125H83.625C84.375 106.125 85.0625 105.813 85.6875 105.188C86.3125 104.563 86.625 103.875 86.625 103.125V99.25H34.375ZM34.375 95.375H86.625V24.625H34.375V95.375ZM34.375 20.75H86.625V16.875C86.625 16.125 86.3125 15.4375 85.6875 14.8125C85.0625 14.1875 84.375 13.875 83.625 13.875H37.375C36.625 13.875 35.9375 14.1875 35.3125 14.8125C34.6875 15.4375 34.375 16.125 34.375 16.875V20.75ZM34.375 20.75V13.875V20.75ZM34.375 99.25V106.125V103.125V99.25Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 18,
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.776b05551c2ae7a5fcad2d97a66772aa.svg";
export { ForwardRef as ReactComponent };